/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { getSensitiveWordAnalyzeQuery } from "../../funcs/getSensitiveWordAnalyzeQuery.js";
import { GetSensitiveWordAnalyzeQueryRequest$zodSchema } from "../../models/getsensitivewordanalyzequeryop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSensitiveWordAnalyzeQueryRequest$zodSchema,
};

export const tool$getSensitiveWordAnalyzeQuery: ToolDefinition<typeof args> = {
  name: "text-get-sensitive-word-analyze-query",
  description: `敏感词分析 (GET)

通过URL查询参数分析单个关键词，便于GET请求调用。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await getSensitiveWordAnalyzeQuery(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
